import api from "../axios";

export const AdminGetVendorEvents = (data) =>
  api.get(`admin/${data}/allevents`, data);
export const getEventsForAdmin = (data) => api.post("admin/getAllEvents", data);
export const EditPopupModal = (data) =>
  api.post("/admin/edit-popup-message", data);
export const getOffersForAdmin = (data) => api.get("admin/getAllOffers", data);
export const getAllVenuesAdmin = (data) =>
  api.get("venue/admin/getAllVenues", data);
export const AdminCreateEvent = (data) => api.post("/admin/create-event", data);
export const AdminCreateOffer = (data) => api.post("/admin/create-offer", data);
export const AdminCreateVendor = (data) =>
  api.post("/admin/create-vendor", data);
export const AdminCreateVenue = (data) => api.post("/admin/create-venue", data);
export const AdminCreateCategory = (data) =>
  api.post("/category/create-category", data);
export const AdminGetAllEvents = (data) => api.get("/admin/getAllEvents", data);
export const AdminDeleteEvent = (data) =>
  api.delete("/admin/delete-event", { data: data });
export const AdminGetRecentEvents = (data) =>
  api.get("/admin/recent-events", data);
export const AdminVerifyEvent = (data) =>
  api.patch("/admin/verify-event", { data: data });
export const AdminEditEvent = (data) => api.patch("/admin/edit-event", data);
export const AdminVerifyVenue = (data) =>
  api.patch(`venue/admin/verify-venue`, data);
export const AdminGetAllOffers = (data) => api.get("/admin/getAllOffers", data);
export const AdminDeleteOffer = (data) =>
  api.delete("/admin/delete-offer", data);
export const AdminEditOffer = (data) => api.patch("/admin/edit-offer", data);
export const AdminStats = (data) => api.get("/admin/stats", data);
export const AdminDeleteVenue = (data) =>
  api.delete("venue/admin/delete-venue", { data: data });
export const AdminEditCategory = (data) =>
  api.put("category/update-category", data);
export const AdminSendNotification = (data) =>
  api.post("/notification/send-notification", data);
export const AdminVerifyVendor = (data) =>
  api.patch(`/admin/verify-vendor`, data);
export const AdminGetAllVendors = (data) =>
  api.get("/admin/getUnverifiedVendors", data);
export const AdminDeleteCategory = (data) =>
  api.delete("/category/delete-category", { data: data });
export const GetVendorData = (data) =>
  api.get(`admin/get-vendor-profile/${data}`, data);
export const AdminGetAllUsers = (data) => api.get("/admin/getAllUsers", data);
export const AdminGetUnverifiedVendors = (data) =>
  api.get("admin/get-unverified-vendors", data);
export const AdminListUsers = (data) =>
  api.get(`/admin/list-all-users/${data}`, data);
export const AdminDeleteUser = (data) =>
  api.delete("/admin/delete-user", { data: data });
export const AdminListVendors = (data) =>
  api.get("/admin/list-all-vendors", data);
export const AdminDeleteVendor = (data) =>
  api.delete(`/admin/delete-vendor`, { data: data });
export const AdminEditVenue = (data) =>
  api.patch("venue/admin/edit-venue", data);
export const AdminEditModal = (data) =>
  api.put("/admin/popup/edit-popup", data);
export const AdminSetVisibilityOfModal = (data) =>
  api.put("/admin/popup/edit-view-popup", data);
export const getPopupModal = (data) =>
  api.get(`/admin/popup/get-popup/${data}`, data);
export const changeArchiveStatus = (data) =>
  api.patch(`/admin/archive-event`, data);
export const changeTrendingStatus = (data) =>
  api.patch(`/admin/trending-event`, data);
export const changeVerifyStatus = (data) =>
  api.patch(`/admin/verifyUnverify-event`, data);
